import styled from 'styled-components';

export const FlexCellContent = styled.div.attrs<{ className?: string }>({
  className: 'table-cell-content md:min-h-[88px]',
})`
  margin: 0;
  display: flex;
  align-items: center;
`;
